package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2025_04_26_Day_1
import com.veldekar.components.logs.Log_2025_04_26_Day_2
import com.veldekar.components.logs.Log_2025_04_26_Day_3
import com.veldekar.components.logs.Log_2025_04_26_Day_4
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2025-04-26")
@Composable
public fun Log_2025_04_26(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Three Terrors of the Greatmarsh",
        ogTitle = "Three Terrors of the Greatmarsh",
        date = LocalDate(2_025, 4, 26),
        aiHint = "Title & description are a Princess Bride reference",
        ogDescription = "One, Slaad — no problem, see Bigglesworth’s bladework. Two, Highwaymen — only fools Falorn. Three, C.O.U.S. (Crustaceans Of Unusual Size) — I don’t think they exist.",
        ogImage = "ai/2025-04-26.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "shimmer-1", dateString = "Shimmer 1")
        Log_2025_04_26_Day_1()
        SessionDayHeader(dayId = "shimmer-2", dateString = "Shimmer 2")
        Log_2025_04_26_Day_2()
        SessionDayHeader(dayId = "shimmer-3", dateString = "Shimmer 3")
        Log_2025_04_26_Day_3()
        SessionDayHeader(dayId = "shimmer-4", dateString = "Shimmer 4")
        Log_2025_04_26_Day_4()
        SessionMediaItem(
            image = "images/pentishInDorvidianEmpire.webp",
            linkImage = "images/pentishInDorvidianEmpire.webp",
            description = "A hand-drawn map snippet on grid paper showing the Dorvidian Empire and the city of Pentish -- the home of Lord Pent, a powerful adversary of the heroes.",
            width = 960,
            height = 540,
        )
    }
}
